import type { Editor } from '@tiptap/core';
import classNames from 'classnames';

import { isNodeSelected } from './../is-node-selected';
import { getPluginContainerClassNames, getPluginFocusClassNames } from './../node-styles';

export const getContainerClasses = (editor: Editor, nodeId: string, isMobile: boolean) => {
  const isFocused = isNodeSelected(editor.state, nodeId);
  return classNames(getPluginContainerClassNames(isMobile), getPluginFocusClassNames(isFocused));
};
